import { CommonModule, DecimalPipe, TitleCasePipe } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { I18NEXT_NAMESPACE, I18NextModule } from 'angular-i18next';
import { TabsModule } from 'ngx-bootstrap/tabs';

import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { EditorModule } from 'primeng/editor';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { TooltipModule } from 'primeng/tooltip';
import { TreeModule } from 'primeng/tree';


import { TableModule } from 'primeng/table';
import { InputDelayModule } from '../directives/input-delay/input-delay.module';
import { DynamicPipe } from '../shared/pipes/dynamic.pipe';
import { TrueFalsePipe } from '../shared/pipes/true-false.pipe';
import { YesNoPipe } from '../shared/pipes/yes-no.pipe';
import { HbSharedUiModule } from '../shared/ui/hb-shared-ui.module';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { InvertedSelectionTreeComponent } from './components/inverted-selection-tree/inverted-selection-tree.component';
import { RichTextComponent } from './components/rich-text/rich-text.component';
import { TreeComponent } from './components/tree/tree.component';
import { ObjectBodyComponent } from './object-container/object-body/object-body.component';
import { ObjectBreadcrumbComponent } from './object-container/object-breadcrumbs/object-breadcrumbs.component';
import { ObjectContainerComponent } from './object-container/object-container/object-container.component';
import { ObjectHeaderComponent } from './object-container/object-header/object-header.component';
import { DrawerItemSubtitlePipe } from './object-drawer/drawer-item-subtitle.pipe';
import { NoResultsFoundComponent } from './object-drawer/no-results-found/no-results-found.component';
import { ObjectDrawerBodyComponent } from './object-drawer/object-drawer-body/object-drawer-body.component';
import { ObjectDrawerContainerComponent } from './object-drawer/object-drawer-container/object-drawer-container.component';
import { ObjectDrawerFilterTagComponent } from './object-drawer/object-drawer-filter-tag/object-drawer-filter-tag.component';
import { ObjectDrawerFilterComponent } from './object-drawer/object-drawer-filter/object-drawer-filter.component';
import { ObjectDrawerFooterComponent } from './object-drawer/object-drawer-footer/object-drawer-footer.component';
import { ObjectDrawerHeaderComponent } from './object-drawer/object-drawer-header/object-drawer-header.component';
import { LoadMoreTileComponent } from './object-drawer/object-drawer-tile-control/load-more-tile/load-more-tile.component';
import { ObjectDrawerTileContainerComponent } from './object-drawer/object-drawer-tile-control/object-drawer-tile-container/object-drawer-tile-container.component';
import { TileComponent } from './object-drawer/object-drawer-tile-control/tile/tile.component';
import { ObjectDrawerTreeControlComponent } from './object-drawer/object-drawer-tree-control/object-drawer-tree-control.component';
import { SectionContainerComponent } from './section-container/section-container.component';
import { CellDataPipe } from './table/pipes/cell-data.pipe';
import { CellEditorControlIdPipe } from './table/pipes/cell-editor-control-id.pipe';
import { ColSpanPipe } from './table/pipes/col-span.pipe';
import { DateTimeFormatterLabelPipe } from './table/pipes/date-time-formatter-label.pipe';
import { FindSelectedOptionPipe } from './table/pipes/find-selected-option.pipe';
import { TableComponent } from './table/table.component';
import { TabsComponent } from './tabs/tabs.component';

@NgModule({
  declarations: [
    TableComponent,
    TreeComponent,
    ColSpanPipe,
    CellDataPipe,
    FindSelectedOptionPipe,
    CellEditorControlIdPipe,
    DynamicPipe,
    ObjectDrawerContainerComponent,
    ObjectDrawerHeaderComponent,
    ObjectDrawerBodyComponent,
    ObjectDrawerTileContainerComponent,
    TileComponent,
    DrawerItemSubtitlePipe,
    SectionContainerComponent,
    ObjectContainerComponent,
    ObjectHeaderComponent,
    ObjectBreadcrumbComponent,
    ObjectBodyComponent,
    LoadMoreTileComponent,
    ObjectDrawerFooterComponent,
    ObjectDrawerTreeControlComponent,
    ObjectDrawerFilterComponent,
    ObjectDrawerFilterTagComponent,
    DateTimeFormatterLabelPipe,
    NoResultsFoundComponent,
    DropdownComponent,
    InvertedSelectionTreeComponent,
    TabsComponent,
    RichTextComponent,
  ],
  imports: [
    CommonModule,
    HbSharedUiModule,
    TableModule,
    DropdownModule,
    FormsModule,
    TooltipModule,
    TreeModule,
    RouterModule,
    CheckboxModule,
    InputTextModule,
    ProgressSpinnerModule,
    ToggleButtonModule,
    InputDelayModule,
    OverlayPanelModule,
    I18NextModule.forRoot(),
    NgSelectModule,
    TabsModule,
    EditorModule,
    MultiSelectModule,
  ],
  exports: [
    TableComponent,
    TreeComponent,
    ObjectDrawerContainerComponent,
    ObjectDrawerHeaderComponent,
    ObjectDrawerBodyComponent,
    ObjectDrawerFooterComponent,
    ObjectDrawerTileContainerComponent,
    TileComponent,
    SectionContainerComponent,
    ObjectContainerComponent,
    ObjectHeaderComponent,
    ObjectBreadcrumbComponent,
    ObjectBodyComponent,
    LoadMoreTileComponent,
    ObjectDrawerTreeControlComponent,
    ObjectDrawerFilterComponent,
    DropdownComponent,
    InvertedSelectionTreeComponent,
    TabsComponent,
    RichTextComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    DecimalPipe,
    DynamicPipe,
    DateTimeFormatterLabelPipe,
    YesNoPipe,
    TrueFalsePipe,
    TitleCasePipe,
    {
      provide: I18NEXT_NAMESPACE,
      useValue: ['module.component-library'],
    },
  ],
})
export class HbComponentLibraryModule { }
